import React, { useEffect, useState } from "react";
import { Outlet, useNavigate, useLocation } from "react-router-dom";
import { SidebarNav } from "@/components/shell/SidebarNav";
import { MobileSidebar } from "@/components/shell/MobileSidebar";
import { TopBar } from "@/components/shell/TopBar";
import { CommandPalette } from "@/components/common/CommandPalette";
import { Toaster } from "@/components/ui/sonner";
import { useAuth } from "@/state/AuthProvider";

export function AppShell() {
  const [cmdOpen, setCmdOpen] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const { isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (!isAuthenticated) navigate("/login", { replace: true });
  }, [isAuthenticated, navigate]);

  // close mobile sidebar on route change
  useEffect(() => { setMobileOpen(false); }, [location.pathname]);

  useEffect(() => {
    const onKey = (e) => {
      if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === "k") {
        e.preventDefault();
        setCmdOpen((v) => !v);
      }
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, []);

  if (!isAuthenticated) return null;

  return (
    <div className="App relative flex min-h-screen bg-[color:var(--canvas)]" data-testid="app-shell">
      <SidebarNav />
      <MobileSidebar open={mobileOpen} onOpenChange={setMobileOpen} />
      <div className="flex min-h-screen flex-1 flex-col min-w-0 bg-background">
        <TopBar onOpenCommand={() => setCmdOpen(true)} onOpenMobileSidebar={() => setMobileOpen(true)} />
        <main className="flex-1 px-4 sm:px-6 lg:px-8 py-6 text-foreground">
          <div className="mx-auto w-full max-w-[1400px]">
            <Outlet />
          </div>
        </main>
      </div>
      <CommandPalette open={cmdOpen} onOpenChange={setCmdOpen} />
      <Toaster position="bottom-right" closeButton richColors />
    </div>
  );
}
